import { render, staticRenderFns } from "./RejectPreOrderRequest.vue?vue&type=template&id=16e70bfb&scoped=true&"
import script from "./RejectPreOrderRequest.vue?vue&type=script&lang=js&"
export * from "./RejectPreOrderRequest.vue?vue&type=script&lang=js&"
import style0 from "./RejectPreOrderRequest.vue?vue&type=style&index=0&id=16e70bfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e70bfb",
  null
  
)

export default component.exports